export default __webpack_public_path__ + "static/media/ct1.2.a9394d6b.png";